let dataa = [
  {
    id: 1,
    title: "Strand Life Sciences Pvt. Ltd.",
    para: `${"With a prompt and enthusiastic team, 1mg is a healthcare platform that genuinely cares about their customers. The diagnostic team of 1mg takes extra efforts to communicate and explain all relevant aspects of the tests and packages to the customers at every step of the process. We would definitely say that associating with 1mg has added another feather to our cap."}`,
    logo_url:
      "https://onemg.gumlet.io/search_widget/strandls_logonew.png?format=auto",
  },
  {
    id: 2,
    title: "City X Ray And Scan Clinic",
    para: `${"We are happy to collaborate with India’s most trusted healthcare online portal. They have an excellent customer support system which is approachable, trustworthy and knowledgeable."}`,
    logo_url:
      "https://onemg.gumlet.io/search_widget/city-logo-option.png?format=auto",
  },
  {
    id: 3,
    title: "Thyrocare Laboratories",
    para: `${"We wanted to collaborate with a diagnostic platform that shares our values of maintaining high quality at every step of the patient journey. From choosing the lab tests to delivering the test reports, 1mg ensures that the quality is intact in the entire process ensuring a smooth patient journey."}`,
    logo_url:
      "https://onemg.gumlet.io/search_widget/thyrocare-logo.png?format=auto",
  },
  {
    id: 4,
    title: "Dr Lal Pathlabs",
    para: `${"With a highly efficient team and a well-knit network of sample collectors, 1mg has become our preferred choice for expansion across the cities. The customer service team of 1mg is extremely polite and calm with the patients. Additionally, phlebotomists utilized by 1mg are well-trained and professional."}`,
    logo_url: "https://onemg.gumlet.io/search_widget/logo_1.png?format=auto",
  },
  {
    id: 5,
    title: "Pathcare Laboratories Ltd.",
    para: `${"1mg is an excellent patient-centric portal. It utilizes a panel of skilled phlebotomists who take blood samples in a hygienic way. 1mg makes constructive effort to ensure customer/ patient satisfaction. It is indeed on a commendable journey of revolutionizing the healthcare scenario of the country."}`,
    logo_url:
      "https://onemg.gumlet.io/search_widget/pathcare-labs-logo.png?format=auto",
  },
  {
    id: 6,
    title: "Mahajan Imaging Centre",
    para: `${"Immensely impressed with 1mg’s outstanding professionalism and the quality of work. We recommend 1mg as a preferred destination for labs seeking a highly competent and trustworthy partner."}`,
    logo_url: "https://onemg.gumlet.io/search_widget/logo.png?format=auto",
  },
];

export default dataa;
